// extracted by mini-css-extract-plugin
export default {"header":"Header_header__hdMZO","start":"Header_start__YQ08y","center":"Header_center__HE4zI","end":"Header_end__L60aA","section":"Header_section__UDHqk"};